import { axios } from '@lib/axios';

import {
    EntryTypeListItemData,
    EntryTypeData,
    EntryTypeCreateForm,
    EntryTypeUpdateForm,
    EntryTypeStatus,
    ServiceListQuery,
    EntryTypeServiceResponse,
    EntryTypeListResponse,
    EntryTypeResponse,
    GetEntryTypeListQuery,
} from 'chaika-frontend-types/frontend-cms';
import { Locale } from 'chaika-enums';

const BASE_URL = '/api/entry-type';

export class EntryTypeApi {
    public static async create(id: string, entryType: EntryTypeCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/version`, { entryType });
    }

    public static async update(id: string, version: number, entryType: EntryTypeUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/version/${version}`, { entryType });
    }

    public static async copy(id: string, version: number, newEntryTypeId: string): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/version/${version}/${newEntryTypeId}`);
    }

    public static async updateStatus(id: string, version: number, status: EntryTypeStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/version/${version}/status`, { entryType: { status } });
    }

    public static async remove(id: string, version: number): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}/version/${version}`);
    }

    public static async getByIds(
        ids: string[],
        params: { withTranslations?: boolean } = {},
    ): Promise<EntryTypeListItemData[]> {
        const res = await axios.get<EntryTypeListResponse>(BASE_URL, { params: { ids: ids.join(), ...params } });

        return res.data.entryTypes;
    }

    public static async getList(params?: GetEntryTypeListQuery): Promise<EntryTypeListResponse> {
        const res = await axios.get<EntryTypeListResponse>(BASE_URL, { params });

        return res.data;
    }

    public static async get(id: string): Promise<EntryTypeData> {
        const res = await axios.get<EntryTypeResponse>(`${BASE_URL}/${id}`);

        return res.data.entryType;
    }

    public static async getVersion(id: string, version: number, locale: Locale = Locale.Ru): Promise<EntryTypeData> {
        const url =
            locale !== Locale.Ru
                ? `${BASE_URL}/${id}/version/${version}/locale/${locale}`
                : `${BASE_URL}/${id}/version/${version}`;

        const res = await axios.get<EntryTypeResponse>(url);
        return res.data.entryType;
    }

    public static async getVersionWithTranslation(
        id: string,
        version: number,
        locale: Locale = Locale.Ru,
    ): Promise<EntryTypeData> {
        const res = await axios.get<EntryTypeResponse>(`${BASE_URL}/${id}/version/${version}/translation`);

        return res.data.entryType;
    }

    public static async getServices(
        id: string,
        version: number,
        params: ServiceListQuery,
    ): Promise<EntryTypeServiceResponse> {
        const res = await axios.get(`${BASE_URL}/${id}/version/${version}/service`, { params });

        return res.data;
    }

    public static async addService(id: string, version: number, serviceId: string): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/version/${version}/service/${serviceId}`);
    }

    public static async removeService(id: string, version: number, serviceId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}/version/${version}/service/${serviceId}`);
    }
}
